/**
 * Miradi Share UX Services
 * Miradi Share UX Services end-point (for internal use only)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Work Plan View Plan Type
 */
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

export type WorkPlanViewPlanTypeEnum = 'Work Units' | 'Expenses';

export const WorkPlanViewPlanTypeEnum = {
    WorkUnits: 'Work Units' as WorkPlanViewPlanTypeEnum,
    Expenses: 'Expenses' as WorkPlanViewPlanTypeEnum
};

marker('Work Units');
marker('Expenses');

